<ape-admin-page-container
  class="w-full h-full flex flex-col self-stretch flex-1"
  [title]="TRANSLATION_KEYS.admin.monitoring.PLACEHOLDER_TITLE | translate"
  [showBackButton]="true"
  [subtitleOnBottom]="true"
  (backClick)="backClick.emit()"
>
  <ng-template #subtitle>
    <div class="flex justify-start items-center gap-2">
      <span class="text-base font-normal text-black">
        {{TRANSLATION_KEYS.admin.monitoring.details.SUBTITLE | translate}} <b>{{processName}}.</b>
      </span>
    </div>
  </ng-template>

  <monitoring-details-counters-template [monitoringDetailsCountersCardData]="monitoringDetailsCountersCardData" />

  <div class="flex flex-row flex-wrap lg:flex-nowrap sm:gap-6 items-start sm:items-center gap-4 w-full">
    <ape-download-button
      [iconSrc]="'assets/icons/xls.svg'"
      [downloadId]="'monitoring-process-report-download'"
      (downloadClick)="onExportProcessReport.emit($event)"
    />

    <ape-button
      class="w-full sm:w-auto"
      cssClass="!py-2.5 !px-3 !rounded-[4px] w-full !w-full !bg-white sm:whitespace-nowrap whitespace-normal"
      [label]="'admin.monitoring.details.SOLITICT_MASSIVE_COMPILATION' | translate"
      [variant]="'primary'"
      [aspect]="'icon-outline'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/mail.svg"
      [disabled]="isSolicitMassiveDevelopmentPlanDisabled"
      [isLoading]="isLoadingSolicitMassiveDevelopmentPlan"
      (buttonClick)="showSolicitMassiveDevelopmentPlanModal()"
    />

    <div class="flex flex-row items-center !w-full sm:w-auto sm:min-w-[200px]">
      <ape-input
        [cssClassInputWrapper]="'!w-full'"
        class="!w-full"
        [showLabelText]="false"
        [cssClass]="'!h-[46px] !w-full'"
        [value]="searchedText"
        (valueChange)="searchChange($event)"
        (onKeyUp)="searchUsers()"
        [placeholder]="TRANSLATION_KEYS.admin.monitoring.SEARCH_PLACEHOLDER | translate"
      />
      <div
        tabindex="0"
        role="button"
        (click)="searchUsers()"
        class="rounded-[0px_3px_3px_0px] h-[46px] w-[46px] text-base font-medium bg-black text-white p-[11px] flex flex-row items-center flex-shrink-0 cursor-pointer"
      >
        <svg-icon
          name="search"
          class="w-[24px] h-[24px]"
          src="assets/icons/search.svg"
          [attr.aria-hidden]="true"
        />
      </div>
    </div>
    <ape-button
      class="w-full sm:w-auto"
      (buttonClick)="advancedFiltersClicked()"
      cssClass="!py-2.5 !px-3 !rounded-[4px] !bg-black w-full !w-full whitespace-nowrap flex-shrink-0"
      [label]="TRANSLATION_KEYS.admin.monitoring.ADVANCED_FILTERS | translate"
      [variant]="'primary'"
      [aspect]="'icon'"
      [size]="'regular'"
      [rounded]="false"
      leftIcon="assets/icons/funnel.svg"
    />
  </div>

  <div
    *ngIf="getActiveFiltersOnPage().length > 0"
    class="w-full flex flex-row items-center"
  >
    <div class="flex flex-row flex-wrap gap-[10px] max-md:flex-nowrap overflow-x-auto">
      <ape-status-badge
        [withCloseIcon]="true"
        *ngFor="let filter of getActiveFiltersOnPage(); trackBy: trackByFn"
        [aspect]="'filter'"
        [kind]="'active-filter'"
        [label]="filter.title"
        [clickable]="true"
        (onCloseBadge)="removeFilterFromPage(filter)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-22px]"></div>

  <div
    class="w-full flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-4 sm:gap-6 mt-[-32px]">
    <div class="flex flex-row items-center flex-wrap gap-2">
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">{{ getActiveFiltersOnPage().length }}</p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ getActiveFiltersOnPage().length === 1 ?
        (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTER | translate) :
        (TRANSLATION_KEYS.admin.monitoring.ACTIVE_FILTERS | translate) }}
      </p>
      <p class="text-base font-bold text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount }}</p>
      <p class="text-base font-light text-[var(--colors-gray-scale-black)]">
        {{ usersDataCount === 1 ?
        (TRANSLATION_KEYS.admin.monitoring.RESULT | translate) :
        (TRANSLATION_KEYS.admin.monitoring.RESULTS | translate) }}
      </p>
    </div>
    <div class="flex flex-row items-center w-full sm:w-auto">
      <ape-select
        class="!w-full sm:!w-auto"
        [isOrderSelect]="true"
        [placeholder]="''"
        [options]="sortOptions"
        [selectedOption]="selectedSortOption"
        optionLabel="title"
        optionValue="id"
        (selectedOptionChange)="onSortChange.emit($event)"
      />
    </div>
  </div>

  <div class="w-full h-[1px] bg-[#EEEEEE] mt-[-12px]"></div>

  <!-- Tabella utenti -->
  <ape-admin-monitoring-users-development-plan-table
    class="mt-[-32px]"
    (impersonateUser)="onImpersonateUser.emit($event)"
    (impersonateManager)="onImpersonateManager.emit($event)"
    [usersData]="usersDataAsMonitoringUserDevelopmentPlanSummaryExtended"
    [processId]="processId"
    [processStatus]="processStatus"
    [isPhaseActive]="isPhaseActive"
    (onSolicitDevelopmentPlan)="showSolicitDevelopmentPlanModal($event)"
    *ngIf="usersData.length > 0 && !loadingUsersData && !loadingUsersDataCount && !loading"
  />

  <!-- Paginazione -->
  <ape-table-pagination
    [total]="totalPages"
    [page]="page"
    [pageSize]="pageSize"
    (pageChange)="onPageChange.emit($event)"
    (pageSizeChange)="onPageSizeChange.emit($event)"
    *ngIf="usersData.length > 0 && !loadingUsersData && !loadingUsersDataCount && !loading"
  />

  <!-- placeholder pagina vuota -->
  <ape-page-placeholder
    *ngIf="!loading && usersData.length === 0 && !loadingUsersData && !loadingUsersDataCount"
    [title]="TRANSLATION_KEYS.admin.monitoring.AT_MOMENT | translate"
    [subtitle]="TRANSLATION_KEYS.admin.monitoring.NO_PERSON_INCLUDED | translate"
    [description]="TRANSLATION_KEYS.admin.monitoring.THERE_ARE_NOT_PERSONS_INCLUSED_ON_PROCESS | translate"
  />

  <ape-process-setup-skeleton *ngIf="loading || loadingUsersData || loadingUsersDataCount" />
</ape-admin-page-container>

<!-- Drawer per i filtri utenti -->
<ape-monitoring-details-filter-process-drawer
  [visible]="isDrawerVisible"
  [evaluationStatusOptions]="evaluationStatusOptions"
  [companyOptions]="companyOptions"
  [officeOptions]="officeOptions"
  [departmentOptions]="departmentOptions"
  [buOptions]="BUOptions"
  [evaluatorOptions]="evaluatorsOptions"
  [developmentPlanStatusOptions]="developmentPlanStatusOptions"
  [selectedEvaluationStatuses]="selectedEvaluationStatuses"
  [selectedCompanies]="selectedCompanies"
  [selectedOffices]="selectedOffices"
  [selectedDepartments]="selectedDepartments"
  [selectedBUs]="selectedBUs"
  [selectedEvaluators]="selectedEvaluators"
  [selectedDevelopmentPlanStatuses]="selectedDevelopmentPlanStatuses"
  [title]="'admin.monitoring.FILTERS' | translate"
  [cancelLabel]="'generic.CANCEL' | translate"
  [confirmLabel]="'admin.monitoring.APPLY_FILTERS' | translate"
  [activeFiltersCount]="getActiveFiltersOnPage().length"
  (evaluationStatusesChange)="onEvaluationStatusesChangeHandler($event)"
  (companyChange)="onCompanyChangeHandler($event)"
  (evaluatorChange)="onEvaluatorChangeHandler($event)"
  (departmentChange)="onDepartmentChangeHandler($event)"
  (officeChange)="onOfficeChangeHandler($event)"
  (buChange)="onBUChangeHandler($event)"
  (developmentPlanStatusesChange)="onDevelopmentPlanStatusesChangeHandler($event)"
  (onConfirm)="onApplyFilters.emit()"
  (onResetFilters)="resetFilters()"
  (onCancel)="onCloseDrawer.emit()"
/>

<!-- Modale conferma riapertura valutazione -->
<ape-modal
  [visible]="isVisibleReopenEvaluationModal"
  [title]="'admin.monitoring.details.REOPEN_EVALUATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_REOPEN' | translate"
  (onCancel)="onCancelReopenEvaluation()"
  (onConfirm)="onConfirmReopenEvaluation()"
  (onClose)="onCancelReopenEvaluation()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.REOPEN_EVALUATION_DESCRIPTION' | translate: {managerFullName:
        selectedUser?.managerForename + ' ' + selectedUser?.managerSurname, userFullName: selectedUser?.forename + ' ' +
        selectedUser?.surname}"></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.REOPEN_EVALUATION_SUBTITLE' | translate}}</strong>
    </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito valutazione -->
<ape-modal
  [visible]="isVisibleSolicitDevelopmentPlanModal"
  [title]="'admin.monitoring.details.SOLICIT_COMPILATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_EVALUATION' | translate"
  (onCancel)="onCancelSolicitDevelopmentPlan()"
  (onConfirm)="onConfirmSolicitDevelopmentPlan()"
  (onClose)="onCancelSolicitDevelopmentPlan()"
>
  <div class="w-full max-w-[820px]">
    <div
      [innerHTML]="'admin.monitoring.details.SOLICIT_COMPILATION_DESCRIPTION' | translate: {userFullName: selectedUser?.forename + ' ' + selectedUser?.surname, managerFullName: selectedUser?.managerForename + ' ' + selectedUser?.managerSurname}"
    ></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>

<!-- Modale conferma sollecito massiva-->
<ape-modal
  [visible]="isVisibleSolicitMassiveDevelopmentPlanModal"
  [title]="'admin.monitoring.details.SOLITICT_MASSIVE_COMPILATION_TITLE' | translate"
  [secondaryActionLabel]="'generic.CANCEL' | translate"
  [primaryActionLabel]="'admin.monitoring.details.CONFIRM_SOLICIT_MASSIVE_EVALUATION' | translate"
  [primaryActionDisabled]="isLoadingSolicitMassiveDevelopmentPlan"
  (onCancel)="onCancelSolicitMassiveDevelopmentPlan()"
  (onConfirm)="onConfirmSolicitMassiveDevelopmentPlan()"
  (onClose)="onCancelSolicitMassiveDevelopmentPlan()"
>
  <div class="w-full max-w-[820px]">
    <div [innerHTML]="'admin.monitoring.details.SOLITICT_MASSIVE_COMPILATION_DESCRIPTION' | translate"></div>
    <div class="mt-4"><strong>{{'admin.monitoring.details.SOLICIT_SUBTITLE' | translate}}</strong> </div>
  </div>
</ape-modal>